export default __webpack_public_path__ + "static/cabin-tiny-home-2-queens-1-22d17f5705064039923005b0e924a5c5.jpg";